import React from 'react';

import TabAgreement from './TabsFundings/TabAgreement';
import TabBudgetCode from './TabsFundings/TabBudgetCode';
import TabType from './TabsFundings/TabType';
import TabStatementEvents from './TabsFundings/TabStatementEvents';
import TabCostAgreements from './TabsFundings/TabCostAgreements';
import TabCostKvrs from './TabsFundings/TabCostKvrs';
import { Tab, Tabs } from '../../components/Tabs';
import BackBtn from '../../components/UI/BackBtn';

const tabs = [
  { label: 'agreement', tabName: 'Соглашение', content: <TabAgreement /> },
  { label: 'budgetCode', tabName: 'Код по бюджетной классификации', content: <TabBudgetCode /> },
  { label: 'type', tabName: 'Тип', content: <TabType /> },
  { label: 'statementEvents', tabName: 'Мероприятия Постановления', content: <TabStatementEvents /> },
  { label: 'costAgrs', tabName: 'Статьи затрат (Соглашение)', content: <TabCostAgreements /> },
  { label: 'costKvrs', tabName: 'Статьи затрат (КВР)', content: <TabCostKvrs /> },
];

export default function AdminFundings() {
  return (
    <section className="page admin-fundings-page">
      <div className="container">
        <BackBtn />
        <div style={{ marginTop: 20 }}>
          <Tabs>
            {tabs
            // .filter(tab => !tab.hide || !tab.hide(userCtx.perms))
              .map((tab, i) => (
                <Tab key={i} label={tab.label} tabName={tab.tabName}>
                  {tab.content}
                </Tab>
              ))}
          </Tabs>
        </div>
      </div>
    </section>
  );
}
